module.exports = __webpack_public_path__ + "static/media/manufacturing.19db0ad1.svg";